import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import Moment from 'moment';
import { translate, Button } from '@haldor/ui';
import LeaveApplicationCardList from './LeaveApplicationCardList';
import LeaveApplicationForm from './LeaveApplicationForm';
import LeaveApplicationView from './View/LeaveApplicationView';
import { getLeaveRequests, revokeLeaveRequest } from 'actions/absence';
import { setPageTitle } from 'actions/header';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Using inline content for Snackbar messages (no MuiAlert wrapper)

var LeavesPage = function LeavesPage(_ref) {
  var translate = _ref.translate,
    getLeaveRequests = _ref.getLeaveRequests,
    student = _ref.student,
    revokeLeaveRequest = _ref.revokeLeaveRequest,
    forms = _ref.forms,
    leaveRequests = _ref.leaveRequests,
    setPageTitle = _ref.setPageTitle;
  var _useState = useState(Moment().subtract(6, 'months').format('YYYY-MM-DD')),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var _useState3 = useState(Moment().add(6, 'months').format('YYYY-MM-DD')),
    _useState4 = _slicedToArray(_useState3, 2),
    endDate = _useState4[0],
    setEndDate = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    leaveModalOpen = _useState6[0],
    setLeaveModalOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    viewModalOpen = _useState8[0],
    setViewModalOpen = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedApplication = _useState0[0],
    setSelectedApplication = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    viewModalError = _useState10[0],
    setViewModalError = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    alertOpen = _useState12[0],
    setAlertOpen = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    alertMessage = _useState14[0],
    setAlertMessage = _useState14[1];
  var _useState15 = useState('success'),
    _useState16 = _slicedToArray(_useState15, 2),
    alertSeverity = _useState16[0],
    setAlertSeverity = _useState16[1];
  useEffect(function () {
    if (getLeaveRequests) getLeaveRequests(startDate, endDate);
    // Set page title for Leaves page
    if (setPageTitle) setPageTitle(translate('Leave application'));
  }, [getLeaveRequests, startDate, endDate]);
  var onLeaveApplicationSubmit = function onLeaveApplicationSubmit() {
    if (getLeaveRequests) getLeaveRequests(startDate, endDate);
    setLeaveModalOpen(false);
  };
  var onLeaveApplicationRevoke = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(application) {
      var _error$response, _error$response2, _error$response3, _error$response4, errorMessage, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (application) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            _context.prev = 1;
            _context.next = 2;
            return revokeLeaveRequest(application.id, student.id);
          case 2:
            if (!getLeaveRequests) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return getLeaveRequests(startDate, endDate);
          case 3:
            setViewModalOpen(false);
            setSelectedApplication(null);
            setViewModalError(null);
            setAlertSeverity('success');
            setAlertOpen(true);
            history.replace('/leaves');
            _context.next = 5;
            break;
          case 4:
            _context.prev = 4;
            _t = _context["catch"](1);
            errorMessage = translate('Failed to revoke leave request');
            if ((_t === null || _t === void 0 || (_error$response = _t.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
              errorMessage = translate('Leave request not found');
            } else if ((_t === null || _t === void 0 || (_error$response2 = _t.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 403) {
              errorMessage = translate('You do not have permission to revoke this request');
            } else if ((_t === null || _t === void 0 || (_error$response3 = _t.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 400) {
              errorMessage = translate('Invalid request. Leave request may already be processed');
            } else if (_t !== null && _t !== void 0 && (_error$response4 = _t.response) !== null && _error$response4 !== void 0 && (_error$response4 = _error$response4.data) !== null && _error$response4 !== void 0 && _error$response4.message) {
              errorMessage = _t.response.data.message;
            }
            setViewModalError(errorMessage);
            setAlertMessage(errorMessage);
            setAlertSeverity('error');
            setAlertOpen(true);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function onLeaveApplicationRevoke(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var _useParams = useParams(),
    routeId = _useParams.id;
  var history = useHistory();
  var onCardClick = function onCardClick(application) {
    // navigate to deep-link which will trigger effect to open modal
    if (application && application.id) {
      history.push("/leaves/".concat(application.id));
    }
  };

  // compute mapped applications same as card list
  var applications = React.useMemo(function () {
    if (!leaveRequests || !Array.isArray(leaveRequests) || leaveRequests.length === 0) return [];
    // require the same mapper used by card list
    var LeaveRequest = require('./class/LeaveRequest')["default"];
    return LeaveRequest.toTableRows(leaveRequests);
  }, [forms, leaveRequests]);

  // open modal if route param exists and matches a loaded application
  useEffect(function () {
    if (routeId && applications.length) {
      var app = applications.find(function (a) {
        return "".concat(a.id) === "".concat(routeId) || "".concat(a.formId) === "".concat(routeId);
      });
      if (app) {
        setSelectedApplication(app);
        setViewModalOpen(true);
        setViewModalError(null);
        if (setPageTitle) setPageTitle(translate('Leave application'));
      } else {
        // if not found, keep modal closed and optionally replace url
      }
    }
    // if no routeId, ensure modal closed
    if (!routeId) {
      setSelectedApplication(null);
      setViewModalOpen(false);
      setViewModalError(null);
    }
  }, [routeId, applications]);
  var leaveFormRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: "page leaves-page"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '12px 0'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "create-button-container",
    style: {
      marginBottom: 12
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setLeaveModalOpen(true);
    }
  }, translate('Apply for leave')), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      mt: 1,
      color: 'text.secondary'
    }
  }, /*#__PURE__*/React.createElement(InfoOutlinedIcon, {
    sx: {
      mr: 1,
      fontSize: '1rem'
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, translate('Shows leave applications six months backward and forward in time.')))), /*#__PURE__*/React.createElement(LeaveApplicationCardList, {
    onClick: onCardClick
  })), /*#__PURE__*/React.createElement(Modal, {
    open: leaveModalOpen,
    onClose: function onClose() {
      if (leaveFormRef.current && leaveFormRef.current.requestClose) {
        leaveFormRef.current.requestClose();
      } else {
        setLeaveModalOpen(false);
      }
    },
    "aria-labelledby": "leave-app-create-title"
  }, /*#__PURE__*/React.createElement(Box, {
    className: "leave-app-modal",
    sx: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: 2,
      p: 0,
      width: {
        xs: '100vw',
        sm: 560
      },
      maxHeight: '90vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: "leave-app-modal__header",
    sx: {
      px: 3,
      py: 2.25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: function borderBottom(theme) {
        return "1px solid ".concat(theme.palette.divider);
      }
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    id: "leave-app-create-title",
    variant: "h6",
    sx: {
      fontSize: '1.05rem',
      fontWeight: 600,
      letterSpacing: '.25px'
    }
  }, translate('Create leave application'))), /*#__PURE__*/React.createElement(Box, {
    className: "leave-app-modal__content",
    sx: {
      px: 3,
      pt: 2.5,
      pb: 3,
      overflowY: 'auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-app-form-wrapper"
  }, /*#__PURE__*/React.createElement(LeaveApplicationForm, {
    ref: leaveFormRef,
    user: student === null || student === void 0 ? void 0 : student.id,
    onSuccess: onLeaveApplicationSubmit,
    onAbort: function onAbort() {
      return setLeaveModalOpen(false);
    }
  }))))), /*#__PURE__*/React.createElement(Modal, {
    open: viewModalOpen,
    onClose: function onClose() {
      setViewModalOpen(false);
      setSelectedApplication(null);
      history.replace('/leaves');
    },
    "aria-labelledby": "leave-app-modal-title",
    "aria-describedby": "leave-app-modal-desc"
  }, /*#__PURE__*/React.createElement(Box, {
    className: "leave-app-modal",
    sx: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: 2,
      p: 0,
      width: {
        xs: '92vw',
        sm: 560
      },
      maxHeight: '86vh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    className: "leave-app-modal__header",
    sx: {
      px: 3,
      py: 2.25,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: function borderBottom(theme) {
        return "1px solid ".concat(theme.palette.divider);
      }
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    id: "leave-app-create-title",
    variant: "h6",
    sx: {
      fontSize: '1.05rem',
      fontWeight: 600,
      letterSpacing: '.25px'
    }
  }, translate('Leave application'))), /*#__PURE__*/React.createElement(LeaveApplicationView, {
    onClose: function onClose() {
      setViewModalOpen(false);
      setSelectedApplication(null);
      history.replace('/leaves');
    },
    onRevoke: onLeaveApplicationRevoke,
    modalError: viewModalError,
    application: selectedApplication,
    translate: translate
  }))), alertMessage && /*#__PURE__*/React.createElement(Box, {
    sx: {
      bgcolor: alertSeverity === 'success' ? 'success.main' : 'error.main',
      color: '#fff',
      px: 2,
      py: 1,
      borderRadius: 1
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, alertMessage)));
};
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    student: state.User.activeStudent,
    forms: state.Templates.forms,
    leaveRequests: state.absence.leaveRequests
  };
}
export default connect(mapStateToProps, {
  getLeaveRequests: getLeaveRequests,
  revokeLeaveRequest: revokeLeaveRequest,
  setPageTitle: setPageTitle
})(LeavesPage);